import { render, staticRenderFns } from "./ClinicShowPharma.vue?vue&type=template&id=2fe3f1e6"
import script from "./ClinicShowPharma.vue?vue&type=script&lang=js"
export * from "./ClinicShowPharma.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports